// LIBRARIES
import { COLORS, DEVICE_TYPE, MARGIN, SIZE } from "constants/variables";
import styled from "styled-components";

//MISC;

export const CivicDialogueContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  // height: 100vh;
  // overflow: hidden; 
`;
export const ScrollWrapper = styled.div`
  grid-row: 1;              
  position: sticky;
  top: 80px;              
  z-index: 100;
  background-color: ${COLORS.Background};

`;

export const SectionsRow2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-row: 2;             
  // overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
   & > *:first-child {
    margin-top: 100px;
  }
`;

export const CarouselWrapper = styled.div`
  height: 552px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;
  margin-bottom: 100px;
  padding: 0px ${MARGIN.max80};
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    height: 637px;
    padding: 0px ${MARGIN.max24};
    margin-bottom: 0px;
    margin-top: 50px;
  }
`;

export const SectionId = styled.div`
scroll-margin-top: 80px;
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${SIZE.max40} 0;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 0;
  }
`;
